import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';

import { envConfig } from 'config';
import paginationParams from 'utils/pagination-params';

export const list = 'LIST_TYPING_TESTS';
export const single = 'SINGLE_TYPING_TEST';

export const typingTestsApi = createApi({
  reducerPath: 'typingTestsApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    testTypingTest: builder.mutation({
      query: (args) => ({
        url: `${envConfig.streamLambdaUrl}/typing-tests/test`,
        method: 'POST',
        body: {
          s3Key: args.s3Key,
          prompts: args.prompts,
          resumeJson: args.resumeJson
        }
      })
    }),
    createTypingTest: builder.mutation({
      query: (typingTest) => ({
        url: '/typing-tests/create',
        method: 'POST',
        body: typingTest
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: created } = await queryFulfilled;
          dispatch(
            typingTestsApi.util.updateQueryData('listTypingTests', undefined, (draft) => {
              draft.data.items.unshift(created.data);
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    updateTypingTest: builder.mutation({
      query: ({ typingTestId, ...attributes }) => ({
        url: `/typing-tests/update/${typingTestId}`,
        method: 'PUT',
        body: { ...attributes }
      }),
      invalidatesTags: [single],
      async onQueryStarted({ typingTestId }, { dispatch, queryFulfilled }) {
        try {
          const { data: updated } = await queryFulfilled;
          dispatch(
            typingTestsApi.util.updateQueryData('listTypingTests', undefined, (draft) => {
              const item = draft.data.items.find((profile) => profile.id === typingTestId);
              if (item) {
                Object.assign(item, updated.data);
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    deleteTypingTest: builder.mutation({
      query: (typingTestId) => ({
        url: `/typing-tests/delete/${typingTestId}`,
        method: 'DELETE'
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            typingTestsApi.util.updateQueryData('listTypingTests', undefined, (draft) => {
              const idx = draft.data.items.findIndex((item) => item.id === id);
              if (idx > -1) {
                draft.data.items.splice(idx, 1);
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    getTypingTestById: builder.query({
      query: (typingTestId) => `/typing-tests/get/${typingTestId}`,
      providesTags: [single]
    }),
    listTypingTests: builder.query({
      query: (params) => ({
        url: '/typing-tests/list',
        params
      }),
      providesTags: [list],
      ...paginationParams
    })
  })
});

export const {
  useTestTypingTestMutation,
  useCreateTypingTestMutation,
  useUpdateTypingTestMutation,
  useDeleteTypingTestMutation,
  useGetTypingTestByIdQuery,
  useListTypingTestsQuery
} = typingTestsApi;
